import { styled } from 'common/styles'

export const Loading = styled('div')`
  background-color: var(--gray-100);
  color: var(--gray-600);
  line-height: var(--spacer-5);
  box-shadow: inset -0.0625rem 0.0625rem 0 0 var(--gray-200);
`
export const Container = styled('div')`
  background-color: var(--black);

  iframe {
    width: 100%;
    height: 100%;
    min-height: 12.5rem;
  }
`
